import defineComponent from 'flight';

function ShopItemSettingsModalOnDisplay() {

    this.defaultAttrs({
        onDisplayCheckBox: '#onDisplayCheckBox',
        quotaReached: '[data-shop-item-settings-quota-reached]',
        itemId: null,
        onDisplay: null,
        onDisplayCount: null,
        maxOnDisplayCount: null
    });

    this._save = function (evt, data) {
        let onDisplay = this._getOnDisplay();
        data.onDisplay = onDisplay;

        if (!this._onDisplayHasChanged(onDisplay)) {
            return;
        }

        this.trigger(document, 'ui:shop-item-settings:on-display-changed', {
            itemId: this.attr.itemId,
            onDisplay: onDisplay
        });
        if (this._gaEvent) {
            this.trigger(document, 'analytics:track-event', this._gaEvent);
        }
    };

    this._onDisplayHasChanged = function (onDisplay) {
        return onDisplay !== this.attr.onDisplay;
    };

    this._setOnDisplay = function (onDisplay) {
        this.$node.find(this.attr.onDisplayCheckBox).prop('checked', onDisplay);
    };

    this._getOnDisplay = function () {
        return this.$node.find(this.attr.onDisplayCheckBox).prop('checked');
    };

    this._setOnDisplayLeft = function (onDisplayLeft) {
        this.$node.find('[data-on-display-left]').html(onDisplayLeft);
    };

    this._setMaxOnDisplayCount = function (maxOnDisplayCount) {
        this.$node.find('[data-max-on-display-count]').html(maxOnDisplayCount);
    };

    this._onDisplayClicked = function () {
        this._gaEvent = {};
        let maxCount = this.attr.maxOnDisplayCount;

        if (this._canChangeOnDisplay()) {
            let newCount = this._updateDisplayCount();
            this._gaEvent.label = 'New on display count: ' + newCount + ' of ' + maxCount;
        } else {
            this._setOnDisplay(false);
            this._showOnDisplayQuotaReachedMessage();
            this._gaEvent.label = 'Cannot change, is at max: ' + maxCount;
        }

        this._gaEvent.category = 'Shop Item Settings';
        this._gaEvent.action = 'On display ' + (this._getOnDisplay() ? 'enabled' : 'disabled');
    };

    this._updateDisplayCount = function () {
        let originalDisplayCount = this.attr.onDisplayCount;
        let originallyChecked = this.attr.onDisplay;
        let checkedNow = this._getOnDisplay();
        let newCount = originalDisplayCount;

        if (originallyChecked && !checkedNow) {
            newCount--;
        } else if (!originallyChecked && checkedNow) {
            newCount++;
        }

        if (newCount < 0) {
            newCount = 0;
        }

        this._setOnDisplayLeft(this.attr.maxOnDisplayCount - newCount);
        return newCount;
    };

    this._canChangeOnDisplay = function () {
        let onDisplayLeft = this.attr.maxOnDisplayCount - this.attr.onDisplayCount;

        if (this.attr.onDisplay) {
            return true;
        }

        return onDisplayLeft > 0;
    };

    this._showOnDisplayQuotaReachedMessage = function () {
        this.select('quotaReached').show();
    };

    this._close = function () {
        this.teardown();
    };

    this.after('initialize', function () {
        this._gaEvent = null;
        this._setOnDisplay(this.attr.onDisplay);
        this._setOnDisplayLeft(this.attr.maxOnDisplayCount - this.attr.onDisplayCount);
        this._setMaxOnDisplayCount(this.attr.maxOnDisplayCount);
        this.on('click', {
            onDisplayCheckBox: this._onDisplayClicked
        });
        this.on(document, 'ui:shop-item-settings-modal:save', this._save);
        this.on(document, 'ui:body-container:on-modal-close', this._close);
    });

    this.around('teardown', function () {
        this.off(document, 'ui:shop-item-settings-modal:save', this._save);
        this.off(document, 'ui:body-container:on-modal-close', this._close);
    });
}

module.exports = defineComponent.component(ShopItemSettingsModalOnDisplay);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/shop-item-settings-modal-on-display.js